import { Component, OnInit, AfterViewInit, Input, ViewChild, QueryList, ViewChildren, Inject, Output, EventEmitter, OnChanges } from '@angular/core';
import { SalesOrder, SubSalesOrder, MarketingIP, PmTechnicalIP, PurchasePOIP, PlanningIP, PurchaseMaterialReceiptIP, ProductionIP, QualityIP, ScmIP, EnggDrawIP, EnggProcureIP, StoreIP, LogisticIP, SSOStatus, SaveStatusObj, Equipment, FunctionStatus, PlannedDateToken, ActualDateToken, SuborderNumbers, PartialDelivery, RequestDateToken, EnggProcFileUploads, GenFileUploads, DataSheetIP, DataSheetSubOrderIP } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTabChangeEvent as MatTabChangeEvent } from '@angular/material/legacy-tabs';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormControl as FormControl } from '@angular/forms';
import { DataService } from '../../../shared/dataservice.service';
import { PmTechnicalSuborderComponent } from '../pm-technical-suborder/pm-technical-suborder.component';
import { ScmComponent } from '../scm/scm.component';
import { FileUploadDialog } from '../../../dialogs/file-upload-dialog/file-upload-dialog';

@Component({
  selector: 'sub-salesorder',
  templateUrl: './sub-salesorder.component.html',
  styleUrls: ['./sub-salesorder.component.css']
})
export class SubSalesorderComponent implements OnChanges, OnInit {

  selectedIndex = 0;
  @Input() soLockObtained:boolean;
  
  @Input() soObj: SalesOrder;
  @Output() updateSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  @Output() deleteSubsaleorder:  EventEmitter<SaveStatusObj> = new EventEmitter();

  subSoList: Array<SubSalesOrder>;
  landingPage: string = '';
  subSoNo: string;

  subSoDatasheetList: Array<DataSheetIP>;
  existingDatasheetSubOrderList: Array<any>;
  inputDisableMessageDatasheet:string = 'This form is not yet enabled';

 
  @ViewChildren('stepper') stepper: any;

  selectedDepartmentIndex = 0;


  constructor(private route: ActivatedRoute, public dialog: MatDialog, public _dataService: DataService) { }
 
  get isLockObtained():boolean{
    return this.soLockObtained;
  }
  ngOnInit(): void {
    this.existingDatasheetSubOrderList = this.getExisitingDatasheetSubOrderList();

  }
ngOnChanges(){
  this.subSoList = this.soObj.subSalesOrder;
  this.subSoDatasheetList = this.soObj.dataSheetIP;
  
  this.route.params.subscribe(params => {
    if (params['subsono'] && params['somodule']) {
      this.landingPage = params['somodule'];
      this.subSoNo = params['subsono'];

      if(this.soObj.subSalesOrder && this.subSoNo){
        let _tmpIndex:number = this.soObj.subSalesOrder.findIndex((_subSOObj:SubSalesOrder) => {
          return _subSOObj.subOrderNoId == this.subSoNo;
        });

        if(_tmpIndex > 0){
          this.selectedIndex = _tmpIndex;
        }
        else{
          this.selectedIndex = 0;
        }
      }
      else{
        this.selectedIndex = 0;
      }

      switch (this.landingPage) {
        case "enggdraw": 
            this.selectedDepartmentIndex = 1;
        break;
        case "scm":
            this.selectedDepartmentIndex = 2;
          break;
        case "engg": 
            this.selectedDepartmentIndex = 3;
        break;
        case "purchase": 
            this.selectedDepartmentIndex = 4;
        break;
        case "planning": 
            this.selectedDepartmentIndex = 5;
        break;
        case "matreceipt": 
            this.selectedDepartmentIndex = 6;
        break;
        case "store": 
            this.selectedDepartmentIndex = 7;
        break;
        case "production":
        this.selectedDepartmentIndex = 8;
          break;
        case "quality":
        this.selectedDepartmentIndex = 9;
          break;
        case "logistic":
        this.selectedDepartmentIndex = 10;
          break;
        case "changenote":
          this.selectedDepartmentIndex = 11;
          break;
        case "newsso":
            //this.openNewSSODialog();
        break;

        default:
          this.selectedDepartmentIndex = 0;
          break;
      }
    }
  });
}
subOrderStepChange(_ent){
  // console.log(_ent.selectedIndex)
  this.selectedDepartmentIndex = _ent.selectedIndex
}

  createNewSubOrderEvent(_evnt:any){
    //{"selSubNumId":this.selectedSubNumId,"copySubNumId":this.selectedCopySubNumId}
    this.addNewSubOrder(_evnt.selSubNumId,_evnt.copySubNumId);
  }

  addNewSubOrder(_selectedSubSoNumId:string, _copyFromSubSoId:string) {
    this._dataService.openLoader();
    if (_selectedSubSoNumId && _copyFromSubSoId && _copyFromSubSoId != "-1") {
      let _tmpSubOrderClone:SubSalesOrder = this.soObj.getSubOrderCloneMainContent(_copyFromSubSoId);
      _tmpSubOrderClone.subOrderNoId = _selectedSubSoNumId;
       this.soObj.addNewSSO(_tmpSubOrderClone); 
    }
    else {
      this.soObj.addNewSSO(SalesOrder.getEmptySubOrder(_selectedSubSoNumId));
    }
    this._dataService.closeLoader();

  }
  showEnggFileUploadManager(_evnt:EnggProcFileUploads, _ndx:number ){
    // console.log('inside enggprocFileManager')
    let _widthPer:number = 80;
    let _header:string = _evnt.headerStr;
    //if(_evnt.source == 'spl_point'){
      //_header = "C40 / C50 / C60 Files";
    //}
    let dialogRef = this.dialog.open(FileUploadDialog, {
      width: _widthPer + '%',
      data: { message: "message", header:_header, files: (_evnt ? _evnt.FileArray : []), readAccess: _evnt.disableUpload }
    }); 

  }

  showGenFileUploadManager(_evnt:GenFileUploads, _ndx:number ){
    // console.log('Tetsing Uploads')
    let _widthPer:number = 80;
    let _header:string = _evnt.headerStr;

    let dialogRef = this.dialog.open(FileUploadDialog, {
      width: _widthPer + '%',
      data: { message: "message", header:_header, files: (_evnt ? _evnt.FileArray : []), readAccess: _evnt.disableUpload }
    }); 

  }


  // openNewSSODialog(): void {
  //   let dialogRef = this.dialog.open(AddSuborderPopup, {
  //     width: '50%',
  //     data: { selectedSubSo: -1, subSaleOrderList: this.soObj.subSalesOrder }
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this._dataService.openLoader();
  //       setTimeout(() => {
  //         this.addNewSubOrder(result.selectedSubSo)
  //       }, 1);
  //     }
  //   });
  // }

  updateSSO(_evnt:SaveStatusObj,_indx:number){
    if(this.updateSalesOrder){
      this.selectedIndex = _indx;
      _evnt.ssoIndex = _indx;
      this.updateSalesOrder.emit(_evnt);
    }
    
  }
  updateDS(_evnt:SaveStatusObj,_indx:number){
    console.log("Update DS called:", _evnt, _indx);
    if(this.updateSalesOrder){
      this.selectedIndex = _indx;
      _evnt.ssoIndex = _indx;
      this.updateSalesOrder.emit(_evnt);
    }
  }
  // deleteSSO(_evnt:SaveStatusObj,_indx:number){
  //   if(this.deleteSubsaleorder){
  //     this.selectedIndex = _indx;
  //     _evnt.ssoIndex = _indx;
  //     this.deleteSubsaleorder.emit(_evnt);
  //   }
    
  // }

  getStatusCSS(_status: FunctionStatus): string {
    if (_status == FunctionStatus.WAITING_FOR_PREV) {
      return "tab-legend white-legend";
    }
    if (_status == FunctionStatus.WAITING_FOR_USER_INPUT) {
      return "tab-legend grey-legend";
    }
    if (_status == FunctionStatus.SUBMITTED_INCOMPLETE) {
      return "tab-legend yellow-legend";
    }
    if (_status == FunctionStatus.SUBMITTED_COMPLETE) {
      return "tab-legend green-legend";
    }
    if (_status == FunctionStatus.SUBMITTED_WAITING_RESPONSE) {
      return "tab-legend blue-legend";
    }
    if (_status == FunctionStatus.NOT_SUBMITTED_BUT_READY) {
      return "tab-legend yellow-legend";
    }
    return "tab-legend white-legend";
  }

  subOrderTabChanged(_evnt:MatTabChangeEvent){
    this.selectedDepartmentIndex = 0;
    this.selectedIndex = _evnt.index;
  }

  getExisitingSubOrderList():Array<SuborderNumbers>{
    let subSoIdList:Array<string> = [];
    this.subSoList.forEach((_subSo:SubSalesOrder) => {
      subSoIdList.push(_subSo.subOrderNoId);
    });
    return this._dataService.suborderNumbers.filter((_subOrdNum:SuborderNumbers) => {
      return subSoIdList.indexOf(_subOrdNum.suborderNumbersId) >= 0;
    });
  }

  public getSubOrderEnable():boolean{

    return this.soObj.isSubOrdesEnabled;
  }

  getExisitingDatasheetSubOrderList(){
    let subSoDatasheetIdList:Array<any> = [];
    if (this.subSoDatasheetList && Array.isArray(this.subSoDatasheetList)) {
      this.subSoDatasheetList.forEach((_ds:DataSheetIP) => {
        subSoDatasheetIdList.push({'dsNumId':_ds.dataSheetId, 'dsNumName': _ds.dataSheetType,'dsDisplayName': 'Datasheet - '+_ds.dataSheetType + ' - ' + _ds.dataSheetId });
      });
    }
    return subSoDatasheetIdList;
  }

  getDatasheetSubOrderEnable(_tmpSubSO):boolean{
    if(this.soObj.dataSheetIP.length > 0){
    if(this.soObj.isDatasheetSubOrderEnabled == false){
      this.inputDisableMessageDatasheet = "Please Approve the Datasheet Handover In the Marketing Template.";
      return false;
    }
    }
    else{
      this.inputDisableMessageDatasheet = "No Datasheet Present in the Sales Order.";
      return false;
    }
    // inputDisableMessageDatasheet
    return true; // TODO : Add the locking logic here
  }
  isDatasheetSubOrderPresent(_subSo : SubSalesOrder):boolean{
    return (_subSo.dataSheetSubOrderIP != null && _subSo.dataSheetSubOrderIP.dataSheetId != null && _subSo.dataSheetSubOrderIP.dataSheetId != '');
  }

  createNewDatasheetSubOrderEvent(_evnt:any){
    //{"selSubNumId":this.selectedSubNumId,"copySubNumId":this.selectedCopySubNumId}
    this.addNewDataSheetSubOrder(_evnt.selSubNumId, _evnt.copySubNumId);
  }
  addNewDataSheetSubOrder(_selectedSubSoNumId:string, _copySubNumId:string) {
      this._dataService.openLoader();
      if (_selectedSubSoNumId) {
        let _tmpDS = this.soObj.dataSheetIP.filter((opt) => opt.dataSheetId == _selectedSubSoNumId)[0];
        let _tmpSubOrderClone: DataSheetSubOrderIP = DataSheetSubOrderIP.getObj(_tmpDS);
        _tmpSubOrderClone.dataSheetId = _selectedSubSoNumId;
        // this.subOrderObj.addNewDSSubSo(_tmpSubOrderClone);
        // Find the sub order to update
        // const subOrderToUpdate = this.soObj.subSalesOrder.find(
        //   so => so.subOrderNoId === _copySubNumId
        // );
        // if (subOrderToUpdate) {
        //   subOrderToUpdate.dataSheetSubOrderIP = _tmpSubOrderClone;
        // }
        this.soObj.subSalesOrder.find(
          so => so.subOrderNoId === _copySubNumId
        ).addNewDSSubSo(_tmpSubOrderClone);
      }
      this._dataService.closeLoader();
  
    }
}


@Component({
  selector: 'add-suborder-popup',
  templateUrl: 'add-suborder-popup.html',
})
export class AddSuborderPopup implements OnInit, OnChanges {
  //disableSelect = new FormControl(false);
  @Input() SubOrderList:Array<SuborderNumbers>;
  @Output() createNewSubOrder: EventEmitter<any> = new EventEmitter();
  @Input() soLock: boolean;
  inputDisableMessage:string = '';

  availableSubOrderList:Array<SuborderNumbers>;
  disableForm: boolean=false;

  selectedSubNumId:string;
  selectedCopySubNumId:string = "-1";
  constructor(public _dataService: DataService
    //public dialogRef: MatDialogRef<AddSuborderPopup>,
    //@Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(){
  }
  ngOnChanges(){
    this.availableSubOrderList = this.getAvailableSubOrderList();
    if(this.availableSubOrderList.length > 0){
      if(this.selectedSubNumId == null){
          this.selectedSubNumId = this.availableSubOrderList[0].suborderNumbersId;
      }
      else{
        var isPrevItemFound:boolean = false;
        for(var i=0;i<this.availableSubOrderList.length;i++){
          if(this.selectedSubNumId == this.availableSubOrderList[i].suborderNumbersId){
            isPrevItemFound = true;
            break;
          }
        }

        if(isPrevItemFound == false){
          this.selectedSubNumId = this.availableSubOrderList[0].suborderNumbersId;
        }
      }
      
    }
    this.disableForm=true;
    if (this.issoLockObtained == false){
      this.inputDisableMessage= "You can't Edit, Sale Order Lock NOT obtained";
    }
    if(this.availableSubOrderList.length == 0 ){
      this.inputDisableMessage= "Suborder Limit Reached";
    }
    else{
      this.disableForm =false
    }
  }
  get issoLockObtained(): boolean{
    return this.soLock;
  }

  getAvailableSubOrderList():Array<SuborderNumbers>{
    return this._dataService.suborderNumbers.filter((_subOrdNum:SuborderNumbers) => {
      return this.SubOrderList.indexOf(_subOrdNum) < 0;
    });
  }
  addNewSubOrder(){
    if(this.selectedSubNumId && this.selectedCopySubNumId){
      this.createNewSubOrder.emit({"selSubNumId":this.selectedSubNumId,"copySubNumId":this.selectedCopySubNumId});
    }
  }


}

